<template>
  <div class="rate-config-set">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="110px">
      <div class="set-block">
        <div class="title">
          <span>租金扣点</span>
          <span class="title-remark">（手动输入百分值）</span>
        </div>
        <el-form-item label="租金扣点" prop="mallRatio" :rules="[{ required: true, message: '请输入租金扣点', trigger: 'blur' }]">
          <el-input @input="value => {changes(value, 'mallRatio')}" oninput="value=value.replace(/[^.\d.]/g,'')" v-model="form.mallRatio" placeholder="请输入租金扣点" class="input">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="set-block">
        <div class="title">
          <span>交易费率</span>
          <span class="title-remark">（选中支付方式后可设置该交易费率，默认费率为0%）</span>
        </div>
        <el-form-item label="支付类型">
          <el-radio-group v-model="payWay" @change="onChangePayWay">
              <el-radio :label="item.payWay" v-for="(item, index) in payWayListConfig" :key="index">{{ item.payWayName }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-checkbox-group v-model="checkPayList" @change="onChangePayType">
            <el-checkbox :label="item.code" v-for="(item, index) in paypPoductConfig" :key="index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="payment-item" v-for="(item, index) in form.defaultRatios" :key="index">
          <el-form-item label="支付方式">
            <el-input v-model="item.payName" :disabled="true" />
          </el-form-item>
          <el-form-item label="默认费率" :rules="{ required: true, message: '请输入默认费率', trigger: 'blur'}" :prop="'defaultRatios.'+ index +'.ratio'">
            <el-input :disabled="payWay == 'NonCombined'" @input="value => {changesT(value, 'defaultRatios', index, 'ratio')}" oninput="value=value.replace(/[^.\d.]/g,'')" v-model="item.ratio" placeholder="请输入默认费率" class="input">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-button type="primary" class="create" @click="addActiviceRatio(item)" v-if="payWay != 'NonCombined'">添加活动费率</el-button>
          <el-divider v-if="index != (form.defaultRatios.length - 1)"></el-divider>
        </div>
      </div>
       <div class="set-block">
        <div class="title">
          <span>补贴结算设置</span>
        </div>
        <div class="payment-item">
          <el-form-item label="是否开始审批">
            <el-radio-group v-model="form.enableSubsidyAudit">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        <el-form-item label="设置结算时间">
        <el-radio-group v-model="form.subsidySettleType">
          <el-radio label="0">T + 1 结算</el-radio>
          <el-radio label="1" class="limit-pay-box " v-if="form.enableSubsidyAudit">
            <span>T +</span>
            <el-form-item label="" prop="subsidyAuditDay">
              <el-input v-model="form.subsidyAuditDay" maxlength="2" :disabled="form.subsidySettleType !== '1'" oninput="value=value.replace(/[^[\d]/g,'')" >
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
           <span>结算</span>
          </el-radio>
          <el-radio label="1" class="limit-pay-box " v-else>
            <span>订单</span>
            <el-form-item label="" prop="subsidyAuditDay">
              <el-input v-model="form.subsidyAuditDay" maxlength="2" :disabled="form.subsidySettleType !== '1'" oninput="value=value.replace(/[^[\d]/g,'')" >
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
           <span>后T+1结算</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
        </div>
      </div>
      <div class="set-block">
        <div class="title">
          <span>活动费率</span>
          <span class="title-remark">（设置活动费率后该支付方式优先执行活动费率，默认费率为0%）</span>
        </div>
        <div class="payment-item" v-for="(item, index) in form.activityRatios" :key="index">
          <el-form-item label="支付方式">
            <el-input v-model="item.payName" :disabled="true" />
          </el-form-item>
          <el-form-item label="活动名称" :rules="(item.ratio || item.ratio === 0 || item.ratio === '0') ? { required: true, message: '请输入活动名称', trigger: 'blur'} : {required: false}" :prop="'activityRatios.'+ index +'.name'">
            <el-input v-model="item.name" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item class="inlineB" label="活动费率" :rules="(item.ratio || item.ratio === 0 || item.ratio === '0') ? { type: 'array', required: true, message: '请选择日期', trigger: 'change'} : {required: false}" :prop="'activityRatios.'+ index +'.dataRange'">
            <el-date-picker
              v-model="item.dataRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-input @input="value => {changesT(value, 'activityRatios', index, 'ratio')}" style="margin-left: 20px;" oninput="value=value.replace(/[^.\d.]/g,'')" v-model="item.ratio" placeholder="请输入活动费率" class="input">
            <template slot="append">%</template>
          </el-input>
          <el-button type="primary" class="create delete" @click="deleteActiviceRatio(index)">删除</el-button>
          <el-divider v-if="index != (form.activityRatios.length - 1)"></el-divider>
        </div>
        <p v-if="form.activityRatios.length <= 0" class="create-coupon-desc activityRatios">请先设置交易费率</p>
      </div>
      <div class="set-block">
        <div class="title">
          <span>优惠券分摊</span>
          <span class="title-remark">（商场与店铺分摊优惠券费用，双方承担费用总和为100%）</span>
        </div>
        <div class="payment-item" v-for="(item, index) in form.couponStoreCostRates" :key="index">
          <el-form-item label="优惠券">
            <el-input v-model="item.name" :disabled="true" />
          </el-form-item>
          <el-form-item label="商场承担费用" :rules="{ required: true, message: '请输入商场承担费用', trigger: 'blur'}" :prop="'couponStoreCostRates.'+ index +'.mallCostRate'">
            <el-input @input="value => {changesT(value, 'couponStoreCostRates', index, 'mallCostRate')}" oninput="value=value.replace(/[^.\d.]/g,'')" v-model="item.mallCostRate" placeholder="请输入商场承担费用" class="input">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="店铺承担费用" :rules="{ required: true, message: '请输入商场承担费用', trigger: 'blur'}" :prop="'couponStoreCostRates.'+ index +'.storeCostRate'">
            <el-input @input="value => {changesT(value, 'couponStoreCostRates', index, 'storeCostRate')}" oninput="value=value.replace(/[^.\d.]/g,'')" v-model="item.storeCostRate" placeholder="请输入店铺承担费用" class="input">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <span class="errorTips" v-if="errorArr.includes(index)">商场承担费用+店铺承担费用不能大于小于100%</span>
          <el-divider v-if="index != (form.couponStoreCostRates.length - 1)"></el-divider>
        </div>
        <el-button v-if="form.couponStoreCostRates.length <= 0" type="primary" class="create-coupon" @click="onAddCoupon">创建优惠券</el-button>
        <p v-if="form.couponStoreCostRates.length <= 0" class="create-coupon-desc">还未使用优惠券，请前往创建优惠券并设置分摊比例</p>
      </div>
    </el-form>
    <div class="footer">
      <el-button type="default" @click="goback">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading" style="color: #fff;">确定</el-button>
    </div>
  </div>
</template>
<script>
import { api_getShopDetailData, api_postStoreRatio } from '@/api/finance'
import { api_getConfig } from '@/api/common'
export default {
  name: "rConfigSet",
  data() {
    const checkDay =(rule, value, callback)=>{
      console.log()
      if (!value&&this.form.subsidySettleType!='0') {
       callback(new Error('请输入结算天数'))
      }else if(value == '0'){
      callback(new Error('请输入1~99之间的整数'))
      }else{
        callback()
      }
    }
    return {
      form: {
        mallRatio: "",
        enableSubsidyAudit:false,
        subsidyAuditDay:'',
        subsidySettleType:'0',
        defaultRatios: [],
        activityRatios: [],
        couponStoreCostRates: [],
      },
      rules: {
         subsidyAuditDay: [{required: true, validator: checkDay}],
      },
      submitLoading: false,
      paypPoductConfig: [],
      paypPoductConfigAll: [],
      checkPayList: [],
      errorArr: [],
      payWayListConfig: [],
      payWay: 'Combined'
    }
  },
  created () {
    // 获取店铺详情
    this.getFinanceStore()
  },
  methods: {
    changes(value, prop){
      if(value > 100) {
        this.form[prop] = 100
      }
    },
    changesT(value, p1, p2, p3){
      if(value > 100) {
        this.form[p1][p2][p3] = 100
      }
    },
    onChangePayWay () {
      this.checkPayList = []
      this.form.defaultRatios = []
      this.form.activityRatios = []
      this.paypPoductConfig = this.paypPoductConfigAll.filter((item) => item.payWay == this.payWay)
    },
    // 获取店铺详情
    async getFinanceStore() {
      const detail = await api_getShopDetailData({id: this.$route.query.id})
      console.log('detail: ', detail);
      this.form.mallRatio = detail.defaultRatio.mallRatio
      this.paypPoductConfigAll = detail.baseInfo.payProduct
      this.paypPoductConfig = detail.baseInfo.payProduct.filter((item) => item.payWay == 'Combined')
      this.payWayListConfig = detail.baseInfo.payWayList
      this.init(detail)
    },
    // 初始化显示
    init (detail) {
      // 支付方式选中
      try {
        this.checkPayList = detail.defaultRatio.settleFeeRatios.map((item) => {
          return item.payType
        })
      } catch (error) {
        this.checkPayList = []
      }
      try {
        // 交易费率
        this.form.defaultRatios = detail.defaultRatio.settleFeeRatios.map((item) => {
          return {
            ratio: item.ratio,
            payType: item.payType,
            payName: item.payTypeName,
            payWay: item.payWay,
          }
        })
        this.payWay = this.form.defaultRatios[0].payWay
        this.paypPoductConfig = detail.baseInfo.payProduct.filter((item) => item.payWay == this.payWay)
      } catch (error) {
        this.form.defaultRatios = []
      }
      try {
        // 活动费率
        this.form.activityRatios = detail.activiceRatio.settleFeeRatios.map((item) => {
          return {
            ratio: item.ratio,
            payType: item.payType,
            payName: item.payTypeName,
            name: item.name,
            dataRange: [item.startDate, item.endDate]
          }
        })
      } catch (error) {
        this.form.activityRatios = []
      }
      try {
        // 补贴结算
        let { enableAudit,settleType} = detail.subsidySettleConfig
        this.form.enableSubsidyAudit = enableAudit
        if(this.form.enableSubsidyAudit){
          if(settleType!='T1'){
          this.form.subsidySettleType = '1'
          this.form.subsidyAuditDay = settleType.substr(1,settleType.length-1)
          }else{
          this.form.subsidySettleType = '0'
          }
        }else{
          if(settleType!='T1'){
          const index = settleType.indexOf('T');
          this.form.subsidySettleType = '1'
          this.form.subsidyAuditDay = settleType.substr(0,index)
          }else{
          this.form.subsidySettleType = '0'
          }
        }
      } catch (error) {
        this.form.enableSubsidyAudit = false
        this.form.settleType = '0'
      }
      try {
        // 优惠券分摊
        this.form.couponStoreCostRates = detail.activiceRatio.activityCoupons.map((item) => {
          item.mallCostRate = (item.mallCostRate * 100).toFixed(2) * 1
          item.storeCostRate = (item.storeCostRate * 100).toFixed(2) * 1
          return item
        })
      } catch (error) {
        this.form.couponStoreCostRates = []
      }

    },
    onChangePayType (value) {
      // 添加数据
      value.forEach((item) => {
        let index = this.form.defaultRatios.findIndex((v) => v.payType === item)
        if (index < 0) {
          let payItme = this.paypPoductConfig.find((val) => val.code === item)
          this.form.defaultRatios.push({
            ratio: 0,
            payType: item,
            payName: payItme.name,
            payWay: payItme.payWay,
          })
        }
      })
      // 删除数据
      let haveData = []
      for(let i in this.form.defaultRatios) {
        let item = this.form.defaultRatios[i]
        let index = value.findIndex((v) => v === item.payType)
        if (index >= 0) {
          haveData.push(item)
        } else {
          // 删除对应的活动费率
          let activiceRatioIndex = this.form.activityRatios.findIndex((v) => v.payType === item.payType)
          if (activiceRatioIndex >= 0) {
            this.form.activityRatios.splice(activiceRatioIndex, 1)
          }
        }
      }
      this.form.defaultRatios = JSON.parse(JSON.stringify(haveData))
    },
    // 添加活动费率
    addActiviceRatio (item) {
      console.log(item)
      let activiceRatioIndex = this.form.activityRatios.findIndex((v) => v.payType === item.payType)
      if (activiceRatioIndex < 0) {
        this.form.activityRatios.push({
          ratio: 0,
          payType: item.payType,
          payName: item.payName,
          name: '',
          dataRange: [],
          payWay: this.payWay,
        })
      } else {
        this.$baseMessage('该活动费率已存在请直接配置', 'info')
      }
    },
    // 删除活动费率
    deleteActiviceRatio (index) {
      this.form.activityRatios.splice(index, 1)
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.checkPayList.length <= 0) {
            this.$baseMessage('请选择至少一个支付方式', 'error')
            return
          }
          this.checkError()
          if(this.errorArr.length > 0){
            return
          }
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              id: this.$route.query.id
            }
            params = JSON.parse(JSON.stringify(params))
            params.activityRatios.forEach((item) => {
              if(item.dataRange.length > 0) {
                item.startDate = this.$moment(item.dataRange[0]).format('x')*1
                item.endDate = this.$moment(item.dataRange[1]).format('x')*1
              }
              delete item.dataRange
              delete item.payName
            })
            params.defaultRatios.forEach((item) => {
              delete item.payName
            })
            let arr = JSON.parse(JSON.stringify(params.activityRatios))
            params.activityRatios = []
            arr.forEach((item) => {
              if(item.ratio || item.ratio === 0 || item.ratio === '0') {
                params.activityRatios.push(item)
              }
            })
            if(params.enableSubsidyAudit){
             params.subsidySettleType == '0'?params.subsidySettleType = 'T1':params.subsidySettleType = `T${params.subsidyAuditDay}`
             }else{
             params.subsidySettleType == '0'?params.subsidySettleType = 'T1':params.subsidySettleType = `${params.subsidyAuditDay}T1`
             }
            await api_postStoreRatio(params)
            this.$baseMessage('操作成功', 'success')
            this.goback()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 创建优惠券
    onAddCoupon() {
      this.$router.push('/market/couponGrant-account/add')
    },

    // 返回
    goback() {
      this.$router.back(-1)
    },
    // 检查优惠券分摊
    checkError () {
      this.errorArr = []
      console.log('this.form.couponStoreCostRates: ', this.form.couponStoreCostRates);
      this.form.couponStoreCostRates.forEach((item, index) => {
        if ( (item.storeCostRate * 1) + (item.mallCostRate * 1) != 100) {
          this.errorArr.push(index)
        }
      })
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.rate-config-set {
  padding: 35px 20px 0;
  padding-bottom: 100px;
  box-sizing: border-box;
  .set-block{
    position: relative;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    .title {
      margin: 0;
      margin-bottom: 30px;
      padding-left: 15px;
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      position: relative;

      .title-remark {
        color: #666666;
        font-size: 14px;
        font-weight: 400;
      }

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 5px;
        height: 25px;
        border-radius: 2px;
        background: #05C8AF;
      }
    }
    .el-input,
    .el-textarea,
    .el-select,
    .el-cascader,
    .el-date-editor {
      width: 350px;
    }
    ::v-deep{
      .el-divider{
        background: #ccc;
        margin: 0;
        margin-bottom: 20px;
        width: calc(100% - 111px);
        margin-left: 111px;
        margin-top: 10px;
      }
      .el-input.is-disabled .el-input__inner{
        color: #333;
      }
      .inlineB.el-form-item{
        display: inline-block;
        width: 464px;
      }

    }
    .create{
      margin-left: 110px;
      margin-bottom: 10px;
    }
    .delete{
      position: absolute;
      right: 0px;
    }
    .create-coupon{
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      top: 0px;
    }
    .create-coupon-desc{
      display: inline-block;
      position: relative;
      left: 50%;
      top: 40px;
      transform: translateX(-88%);
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
    .activityRatios.create-coupon-desc{
      top: -10px;
      margin: 80px 0;
    }
  }
  .set-block:last-child{
    border: 0;
  }
  .footer{
    position: fixed;
    bottom: 0;
    height: 80px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    padding-left: 70px;
    padding-top: 23px;
    box-sizing: border-box;
    bottom: 0;
    button{
      padding: 0;
      height: 34px;
      text-align: center;
      width: 110px;
      font-size: 16px;
      color: #666666;
      border: 0;
    }
  }
  .errorTips{
    margin-left: 110px;
    color: red;
    font-size: 12px;
    margin-bottom: 10px;
    display: inline-block;
  }
  .limit-pay-box {
    .el-radio__label {
    .el-form-item {
      display: inline-block;
      margin: 0;
      margin-left: 15px;
      .el-input {
        width: 120px !important;
      }
    }
  }
  }
}
</style>
